import React from "react";

export default function Contact() {
  return (
    <div className="container-md " id="contact">
      <div className="row text-center">
        <br />
        <hr />
        <p className="IBM-Plex-Mono fs-3 ">Contact Me</p>
        <hr />
      </div>
      <div className="card text-center">
        <div className="card-header">Links</div>
        <div className="card-body">
          <ul className="list-group list-group-flush Space-Mono">
            <li className="list-group-item  ">
              <i class="fa-brands fa-github me-3 fs-4"></i>
              <a
                href="https://github.com/prathmesh49"
                id="contact-github"
                className="unLine-none"
              >
                <span className="card-text unLine-none">
                  github.com/prathmesh49
                </span>
              </a>
            </li>
            <li className="list-group-item">
              <a
                href="mailto: prathmesh_kurane@yahoo.com"
                className="unLine-none"
              >
               <i class="fa-regular fa-envelope fa-lg me-3 fs-4"></i>
                <span className="fs-6 card-text" id="contact-email">
                  kurapratham3@gmail.com
                </span>
              </a>
            </li>
            <li className="list-group-item">
              <a
                href="https://www.linkedin.com/in/pratham-kurane/"
                id="contact-linkedin"
                className="unLine-none"
              >
                <i class="fa-brands fa-linkedin-in me-3 fs-4"></i>
                <span className="card-text">
                  linkedin.com/in/pratham-kurane
                </span>
              </a>
            </li>
            <li className="list-group-item">
              <i class="fa-solid fa-mobile-retro me-3 fs-4"></i>
              <span className="card-text" id="contact-phone">
                +91 9158 264955
              </span>
            </li>
          </ul>
          <br />
          <br />
          <br />
        </div>
        <div className="card-footer text-body-secondary">
          <p className="cp-text">Created by Prathmesh Kurane © Copyright</p>
        </div>
      </div>
    </div>
  );
}
